import React from "react";
import { Form } from "react-bootstrap";
import { Col, Container, Row, Input, Label } from "reactstrap";
import Section from "./Section";
//Import Images
import contactImage from "../../assets/images/auth/fish_back.png";

const ContactContent = () => {
  return (
    <React.Fragment>
      <section className="section gaps bg-light" style={{ paddingTop: "80px" }}>
        <Container fluid>
          <Section link="Contact" />
          <Row
            className="align-items-stretch sd-flex"
            style={{ margin: "10px", minHeight: "100%", marginTop: "0px" }}
          >
            <Col
              lg={4}
              className="order-first d-flex flex-column"
              style={{
                background: "#003B8F",
                padding: "40px",
                color: "white",
                borderRadius: "20px",
                minHeight: "100%",
              }}
            >
              <h3 className="title">Get in touch</h3>
              <p className="text-white">
                Start working with Jobcy that can provide everything you need to
                generate awareness, drive traffic, connect.
              </p>

              <div className="mt-4 pt-3 flex-grow-1">
                <div className="d-flex text-white align-items-center mt-2">
                  <div className="flex-shrink-0 fs-22 text-primary">
                    <i className="uil uil-map-marker"></i>
                  </div>
                  <div className="flex-grow-1 ms-2">
                    <p className="mb-0">
                      2453 Clinton Street, Little Rock, California, USA
                    </p>
                  </div>
                </div>
                <div className="d-flex text-white align-items-center mt-2">
                  <div className="flex-shrink-0 fs-22 text-primary">
                    <i className="uil uil-envelope"></i>
                  </div>
                  <div className="flex-grow-1 ms-2">
                    <p className="mb-0">contactus@Jobcy.com</p>
                  </div>
                </div>
                <div className="d-flex text-white align-items-center mt-2">
                  <div className="flex-shrink-0 fs-22 text-primary">
                    <i className="uil uil-phone-alt"></i>
                  </div>
                  <div className="flex-grow-1 ms-2">
                    <p className="mb-0">(+245) 223 1245</p>
                  </div>
                </div>
              </div>
              <img
                src={contactImage}
                className="mt-auto"
                style={{ width: "300px" }}
              />
            </Col>

            <Col
              lg={8}
              className="d-flex flex-column"
              style={{ minHeight: "100%" }}
            >
              <div
                className="section-title mt-4 mt-lg-0 flex-grow-1 d-flex flex-column"
                style={{
                  background: "white",
                  padding: "40px",
                  borderRadius: "20px",
                }}
              >
                <Form
                  method="post"
                  className="contact-form mt-4 flex-grow-1 d-flex flex-column"
                  name="myForm"
                  id="myForm"
                >
                  <span id="error-msg"></span>
                  <Row>
                    <Col lg={12}>
                      <div className="mb-3">
                        <Input
                          type="text"
                          name="name"
                          id="name"
                          className="form-control"
                          placeholder="Enter your name"
                          style={{
                            background: "rgb(248, 249, 252)",
                            color: "grey",
                          }}
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <Input
                          type="email"
                          className="form-control"
                          id="email"
                          name="email"
                          placeholder="Enter your email"
                          style={{
                            background: "rgb(248, 249, 252)",
                            color: "grey",
                          }}
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <Input
                          type="text"
                          className="form-control"
                          name="subject"
                          placeholder="Enter your subject"
                          style={{
                            background: "rgb(248, 249, 252)",
                            color: "grey",
                          }}
                        />
                      </div>
                    </Col>
                    <Col lg={12} style={{ height: "100%" }}>
                      <div className="mb-3" style={{ minHeight: "100%" }}>
                        <textarea
                          className="form-control"
                          placeholder="Enter your message"
                          name="comments"
                          style={{
                            background: "rgb(248, 249, 252)",
                            color: "grey",

                            height: "300px", // Adjust 300px based on header and padding
                          }}
                        ></textarea>
                      </div>
                    </Col>
                  </Row>
                  <div className="text-end mt-auto">
                    <button
                      type="button"
                      id="submit"
                      name="submit"
                      className="btn btn-black btn-secondary"
                    >
                      Send Message <i className="uil uil-message ms-1"></i>
                    </button>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <div className="map" style={{ margin: "40px", borderRadius: "20px" }}>
        <iframe
          title="maps"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6509157.364974411!2d-123.79641389801948!3d37.193115265681!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb9fe5f285e3d%3A0x8b5109a227086f55!2sCalifornia%2C%20USA!5e0!3m2!1sen!2sin!4v1628684675253!5m2!1sen!2sin"
          height="350"
          style={{ border: `0`, width: `100%`, borderRadius: "20px" }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
    </React.Fragment>
  );
};

export default ContactContent;
